import { render, staticRenderFns } from "./VehicleCreateForm.vue?vue&type=template&id=225ee0f6&scoped=true"
import script from "./VehicleCreateForm.vue?vue&type=script&lang=js"
export * from "./VehicleCreateForm.vue?vue&type=script&lang=js"
import style0 from "./VehicleCreateForm.vue?vue&type=style&index=0&id=225ee0f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225ee0f6",
  null
  
)

export default component.exports